<template>
  <b-modal
    ref="force-session-box"
    size="md"
    centered
    no-close-on-backdrop
    hide-footer
    hide-header
    @hide="closeModal"
  >
    <p class="mb-4 fs-14 d-flex">
      <img src="../assets/images/alert.svg" class="mr-3" alt />
      <span v-text="type.title" />
    </p>
    <b-row>
      <b-col md="6">
        <label class="pl-0">Terminal</label>
        <p v-text="type.terminal" />
      </b-col>
      <b-col md="6">
        <label class="pl-0">Session opened at</label>
        <p v-text="type.opening_time" />
      </b-col>
      <b-col md="6">
        <label class="pl-0">Opening Balance</label>
        <p
          v-text="`${currencySymbol}${parseFloat(type.opened_at).toFixed(2)}`"
        />
      </b-col>
      <b-col md="6">
        <label class="pl-0">Closing Balance</label>
        <b-input
          placeholder="Enter closing balance"
          v-model="closingBalance"
          :readonly="$loading"
          type="number"
          v-negative-disable
        />
      </b-col>
      <!-- <b-col md="6">
        <label class="pl-0">Total Cash sale (18)</label>
        <p>{{ currencySymbol }} 48,500.00</p>
      </b-col>
      <b-col md="6">
        <label class="pl-0">Total Cash-in (2)</label>
        <p>{{ currencySymbol }} 2,500.00</p>
      </b-col>
      <b-col md="6">
        <label class="pl-0">Total Cash-out (0)</label>
        <p>{{ currencySymbol }} 0.00</p>
      </b-col> -->
      <b-col md="12" class="fs-12 mt-3">
        <p>
          You can only have one active session at a time. To open a new session
          on this terminal you must close any other active session on any
          terminal.
        </p>
        <p>Do you wish to force close the previous session?</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <footer class="mt-4">
          <div class="d-flex">
            <b-button
              type="submit"
              block
              class="mr-1"
              :disabled="$loading"
              @click="logout"
            >
              <span v-if="!$loading || btnAction != 'logout'">Logout</span>
              <b-spinner small v-if="$loading && btnAction == 'logout'" />
            </b-button>
            <b-button
              type="submit"
              block
              class="ml-1"
              variant="danger"
              @click="forceClose"
              :disabled="$loading || closingBalance == ''"
              v-shortkey="['enter']"
              @shortkey="forceClose"
            >
              <span v-if="!$loading || btnAction != 'force'"
                >Force Close Session</span
              >
              <b-spinner small v-if="$loading && btnAction == 'force'" />
            </b-button>
          </div>
        </footer>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "session-force-close",
  props: ["open"],
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    type() {
      let temp = {};
      if (this.state.system.settings.settlement.force_session_close.status == 1)
        temp = {
          title: "Session Active on other Terminal",
          terminal: this.state.system.settings.settlement.force_session_close
            .details.terminal_name,
          opening_time: this.state.system.settings.settlement
            .force_session_close.details.open_at,
          opened_at: this.state.system.settings.settlement.force_session_close
            .details.opening_balance,
          id: this.state.system.settings.settlement.force_session_close.details
            .session_id,
        };
      else if (this.state.system.settings.settlement.sessionExpire.status == 1)
        temp = {
          title: "Previous Session Expired",
          terminal: this.state.system.settings.settlement.sessionExpire.details
            .terminal_name,
          opening_time: this.state.system.settings.settlement.sessionExpire
            .details.open_at,
          opened_at: this.state.system.settings.settlement.sessionExpire.details
            .opening_balance,
          id: this.state.system.settings.settlement.sessionExpire.details
            .session_id,
        };
      return temp;
    },
  },
  data() {
    return {
      btnAction: "",
      closingBalance: "",
    };
  },
  watch: {
    open() {
      if (this.open) this.$refs["force-session-box"].show();
      else this.$refs["force-session-box"].hide();
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-force-modal");
    },
    forceClose() {
      if (this.closingBalance == "") return;
      this.$loading = true;
      this.btnAction = "force";
      let postData = {
        url: "/vendor/force-closed",
        type: "CASH",
        trans_from: this.state.system.trans_from,
        closing_balance: this.closingBalance,
        settlement_date: this.$moment(new Date()).format("YYYY-MM-DD"),
        session_type: "close",
        idddd: this.type.id,
      };
      let data = Object.assign(postData, this.essentialsData);

      axios
        .post(data.url, data)
        .then(() => {
          this.closingBalance = "";
          // this.$loading = false;
          this.getSettings();
        })
        .catch(() => (this.$loading = false));
    },
    getSettings() {
      this.$loading = true;
      let country_details = {
        phone_digit: 10,
        dial_code: "+91",
        country_id: 101,
      };
      this.$store
        .dispatch("system/getLatestSettings")
        .then(() => {
          if (
            this.state.system.settings.vendor_login_details.hasOwnProperty(
              "country_details"
            )
          ) {
            country_details = this.state.system.settings.vendor_login_details
              .country_details;
          }
          this.$store.commit("system/getCountryDetails", country_details);
          this.$loading = false;
          this.closeModal();
        })
        .catch(() => {
          this.$loading = false;
        });
      this.state.system.last_setting_invoked = this.$moment().format(
        "MMMM Do YYYY, h:mm:ss a"
      );
    },
    logout() {
      this.btnAction = "logout";
      this.closeModal();
      this.$loading = true;
      this.$store.dispatch("sessions/logout").then(() => {
        this.$router.push("/");
        this.$loading = false;
      });
    },
  },
};
</script>

<style></style>
